var map = {
	"./close.png": "4521",
	"./close@2x.png": "8e4c",
	"./language.png": "11ab",
	"./language@2x.png": "22be",
	"./logo_black.png": "f1d3",
	"./logo_black@2x.png": "586e",
	"./logo_gray.png": "0c79",
	"./logo_gray@2.png": "ad3d",
	"./logo_white.png": "002e",
	"./logo_white@2x.png": "71d6",
	"./no_logo_white@2x.png": "de72",
	"./search-icon.png": "96e1",
	"./search-icon@2x.png": "d861",
	"./search-white@2x.png": "cd03"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4d74";